// export const FormInput = ({
//   label,
//   name,
//   type,
//   placeholder,
//   value,
//   onChange,
//   error,
//   showIcon,
//   togglePopup,
// }) => {
//   return (
//     <div className="">
//       <div className="w-full h-4 flex justify-between items-center">
//         <label htmlFor="frameNo" className="block text-sm font-medium">
//           {label}
//         </label>
//         {showIcon && (
//           <svg
//             width="32"
//             height="32"
//             onClick={togglePopup}
//             className="p-2"
//             viewBox="0 0 20 20"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               fill-rule="evenodd"
//               clip-rule="evenodd"
//               d="M9.99996 18.3337C5.39746 18.3337 1.66663 14.6028 1.66663 10.0003C1.66663 5.39783 5.39746 1.66699 9.99996 1.66699C14.6025 1.66699 18.3333 5.39783 18.3333 10.0003C18.3333 14.6028 14.6025 18.3337 9.99996 18.3337ZM9.99996 16.667C11.7681 16.667 13.4638 15.9646 14.714 14.7144C15.9642 13.4641 16.6666 11.7684 16.6666 10.0003C16.6666 8.23221 15.9642 6.53652 14.714 5.28628C13.4638 4.03604 11.7681 3.33366 9.99996 3.33366C8.23185 3.33366 6.53616 4.03604 5.28591 5.28628C4.03567 6.53652 3.33329 8.23221 3.33329 10.0003C3.33329 11.7684 4.03567 13.4641 5.28591 14.7144C6.53616 15.9646 8.23185 16.667 9.99996 16.667ZM9.16662 13.3337H10.8333V15.0003H9.16662V13.3337ZM9.16662 11.6737C9.16662 11.6737 10.8333 11.667 10.8333 11.6737C10.8333 10.8387 13.3333 10.0003 13.3333 8.33366C13.3333 6.49199 11.8558 5.00032 10.0075 5.00032C9.56909 4.99934 9.13483 5.08483 8.72954 5.2519C8.32426 5.41898 7.95591 5.66435 7.64559 5.97398C7.33526 6.28361 7.08906 6.6514 6.92108 7.05631C6.75309 7.46122 6.66662 7.89529 6.66663 8.33366H8.33329C8.33329 7.41699 9.08329 6.66699 9.99996 6.66699C10.9166 6.66699 11.6666 7.41699 11.6666 8.33366C11.6666 9.08366 9.16662 10.3062 9.16662 11.6737Z"
//               fill="black"
//             />
//           </svg>
//         )}
//       </div>
//       <input
//         type={type}
//         id={name}
//         name={name}
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         className="mt-1 w-full p-3 bg-[#f1f1f1] outline-none focus:ring-2 focus:ring-orange-400 text-black"
//       />
//       {error && <span className="text-red-500 text-sm">{error}</span>}
//     </div>
//   );
// };

export const FormInput = ({
    label,
    name,
    type,
    placeholder,
    value,
    onChange,
    error,
    showIcon,
    togglePopup,
    // showCheckbox,
    // checkboxLabel,
    // checkboxName,
    // checkboxChecked,
    // onCheckboxChange,
    showButtons,
    onVerifyClick,
    onResetClick,
    verifyButtonValue,
    // isReadOnly,
  }) => {
    return (
      <div className="w-full">
        <div className='w-full h-4 flex justify-between items-center'>
        <label htmlFor={name} className='block text-sm font-medium'>
          {label}
          {!["wowNo", "useCase", "ageGroup"].includes(name) && (
            <span className="text-red-500">*</span>
          )}
        </label>
        {showIcon && (
          <svg
            width='32'
            height='32'
            onClick={togglePopup}
            className='p-2'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M9.99996 18.3337C5.39746 18.3337 1.66663 14.6028 1.66663 10.0003C1.66663 5.39783 5.39746 1.66699 9.99996 1.66699C14.6025 1.66699 18.3333 5.39783 18.3333 10.0003C18.3333 14.6028 14.6025 18.3337 9.99996 18.3337ZM9.99996 16.667C11.7681 16.667 13.4638 15.9646 14.714 14.7144C15.9642 13.4641 16.6666 11.7684 16.6666 10.0003C16.6666 8.23221 15.9642 6.53652 14.714 5.28628C13.4638 4.03604 11.7681 3.33366 9.99996 3.33366C8.23185 3.33366 6.53616 4.03604 5.28591 5.28628C4.03567 6.53652 3.33329 8.23221 3.33329 10.0003C3.33329 11.7684 4.03567 13.4641 5.28591 14.7144C6.53616 15.9646 8.23185 16.667 9.99996 16.667ZM9.16662 13.3337H10.8333V15.0003H9.16662V13.3337ZM9.16662 11.6737C9.16662 11.6737 10.8333 11.667 10.8333 11.6737C10.8333 10.8387 13.3333 10.0003 13.3333 8.33366C13.3333 6.49199 11.8558 5.00032 10.0075 5.00032C9.56909 4.99934 9.13483 5.08483 8.72954 5.2519C8.32426 5.41898 7.95591 5.66435 7.64559 5.97398C7.33526 6.28361 7.08906 6.6514 6.92108 7.05631C6.75309 7.46122 6.66662 7.89529 6.66663 8.33366H8.33329C8.33329 7.41699 9.08329 6.66699 9.99996 6.66699C10.9166 6.66699 11.6666 7.41699 11.6666 8.33366C11.6666 9.08366 9.16662 10.3062 9.16662 11.6737Z'
              fill='white'
            />
          </svg>
        )}
      </div>
  
        <div className={`flex flex-col sm:flex-row ${name === "wowNo" && 'gap-4'}`}>
          <div className="w-full ">
            <input
              type={type}
              id={name}
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              className={`${name === "purchaseDate" ? `p-[11px]` : `p-3`} ${name === "dealerName" && 'mt-2'}
            } mt-1 w-full bg-[#f1f1f1] outline-none focus:ring-2 focus:ring-orange-400 text-black`}
          />
              
            {/* {showCheckbox && (
              <div className="flex items-center gap-1">
                <input
                  type="checkbox"
                  id={checkboxName}
                  name={checkboxName}
                  checked={checkboxChecked}
                  onChange={onCheckboxChange}
                  className="mr-2"
                />
                <label htmlFor={checkboxName} className="text-xs text-nowrap">
                  {checkboxLabel}
                </label>
              </div>
            )} */}
            {error && <span className='text-red-500 text-xs'>{error}</span>}
            </div>
          
            <div>
          {showButtons && (
            <div className='mt-2 flex gap-2 w-full'>
              <button
                type='button'
                className='w-full px-4 py-2 bg-[#ec1c24] sm:text-sm text-white'
                onClick={onVerifyClick}
                disabled={verifyButtonValue === 'Verified'}
              >
                {/* Verify */}
                {verifyButtonValue}
              </button>
              <button
                type='button'
                className='w-full px-4 py-2 bg-gray-500 text-white'
                onClick={onResetClick}
              >
                Reset
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}



         